import { getApiEnvironmentConfig } from '../../utils/api_environment';

const urls = () => {
  const { apiDomain, socketHost } = getApiEnvironmentConfig();

  return {
    wschat: `wss://${socketHost}/v1.0/ws`,
    total_unread: `${apiDomain}/v1.0/messages/unread/total`,
    student_details: `${apiDomain}/student/api/account_info`,
    file_upload: `${apiDomain}/v1.0/upload/chat`,
    url_shortner: `${apiDomain}/v2/url_shortner`,
    session_image_html: `${apiDomain}/v2/schedule_session/student/session_image_html`,
    student_profile_details: `${apiDomain}/v2/student_profile/details`,
    teacher_profile_details: `${apiDomain}/v2/teacher/profile/details`,
    home_data: `${apiDomain}/v2/home/data`,
    get_student_notifications: `${apiDomain}/student/api/get_notifications`,
    student_update_notification_read_status: `${apiDomain}/student/api/update_notification_read_status`,
    teacher_details: `${apiDomain}/teacher/api/teachers_details`,
    teacher_notification_summary: `${apiDomain}/teacher/api/get_new_notifications_summary`,
    teacher_get_notifications: `${apiDomain}/teacher/api/get_notifications`,
    teacher_update_notification_read_status: `${apiDomain}/teacher/api/update_notification_read_status`,
    teacher_get_all_upload_image: `${apiDomain}/v2/schedule_session/teacher/session_images/listall`,
    community_unread_count: `${apiDomain}/v2/nodebb/unread/count` // community_unread_count API endpoint for unread count
  };
};

export default urls();
